export default __webpack_public_path__ + "static/flipImg3-da284d113b92e3dc6a80d266377d9332.webp";